import { render, staticRenderFns } from "./signCreaditBook.vue?vue&type=template&id=3d884c60&scoped=true"
import script from "./signCreaditBook.vue?vue&type=script&lang=js"
export * from "./signCreaditBook.vue?vue&type=script&lang=js"
import style0 from "./signCreaditBook.vue?vue&type=style&index=0&id=3d884c60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d884c60",
  null
  
)

export default component.exports